import React from 'react';

function MenuIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path d="M1.25,2.25a1.25,1.25,0,0,0,0,2.5h17.5a1.25,1.25,0,0,0,0-2.5Z" />
      <path d="M1.25,8.75a1.25,1.25,0,0,0,0,2.5h17.5a1.25,1.25,0,0,0,0-2.5Z" />
      <path d="M0,16.5a1.25,1.25,0,0,1,1.25-1.25h17.5a1.25,1.25,0,0,1,0,2.5H1.25A1.25,1.25,0,0,1,0,16.5Z" />
    </svg>
  );
}

export default MenuIcon;
